import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import UserService from '@/services/user.service';
import { ClubService } from '@/services/club.service';

interface OrganizerDisplayProps {
    organizerId: number;
    clubId?: number;
    organizerName?: string;
    clubName?: string;
}

export const OrganizerDisplay: React.FC<OrganizerDisplayProps> = ({ 
    organizerId, 
    clubId, 
    organizerName,
    clubName 
}) => {
    const [name, setName] = useState<string>('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOrganizerName = async () => {
            try {
                // Если организатор - это клуб (organizerId совпадает с clubId)
                if (clubId && organizerId === clubId) {
                    if (clubName) {
                        setName(clubName);
                        setLoading(false);
                        return;
                    }
                    // Пытаемся загрузить клуб
                    try {
                        const club = await ClubService.getClubById(organizerId);
                        setName(club.name);
                        setLoading(false);
                        return;
                    } catch (clubError) {
                        // Если не удалось загрузить клуб, пробуем как пользователя
                    }
                }

                // Если есть готовое имя организатора
                if (organizerName) {
                    setName(organizerName);
                    setLoading(false);
                    return;
                }

                // Пытаемся загрузить как пользователя
                try {
                    const user = await UserService.getById(organizerId);
                    setName(user.name || `${user.lastName} ${user.firstName}`.trim() || `ID: ${organizerId}`);
                } catch (userError) {
                    // Если не удалось загрузить как пользователя, пробуем как клуб
                    try {
                        const club = await ClubService.getClubById(organizerId);
                        setName(club.name);
                    } catch (clubError) {
                        setName(`ID: ${organizerId}`);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch organizer name:', error);
                setName(`ID: ${organizerId}`);
            } finally {
                setLoading(false);
            }
        };

        if (organizerId) {
            fetchOrganizerName();
        } else {
            setLoading(false);
            setName('Не указан');
        }
    }, [organizerId, clubId, organizerName, clubName]);

    if (loading) return <Spin size="small" />;
    return <span>{name}</span>;
};
